import Skeleton from 'react-loading-skeleton';

const DefaultSkeleton = Skeleton;

export { DefaultSkeleton as Skeleton };
